import { useMutation } from "@apollo/client"
import React from "react"
import styled from "styled-components"
import Button from "../../../components/Button"
import strings from "../../../components/localization/strings"
import Title from "../../../components/Title"
import { Paragraph } from "../../Dashboard/styles"
import {
  deleteMarketingInsight,
  deleteMarketingInsightVariables,
} from "../../../@types/graphql"
import { DELETE_MARKET_INSIGHTS, FETCH_MARKETING_INSIGHTS } from "../query"

const ButtonView = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
`

const ConfirmDeleteInsight = ({
  marketId,
  onCancel,
  onSuccess,
  onError,
  parentCallback,
}: {
  marketId: string
  onCancel: () => void
  onSuccess: () => void
  parentCallback: () => void
  onError: (error: string) => void
}) => {
  const [deleteInsightMutation, { loading: deletingInsight }] = useMutation<
    deleteMarketingInsight,
    deleteMarketingInsightVariables
  >(DELETE_MARKET_INSIGHTS, {
    refetchQueries: [
      {
        query: FETCH_MARKETING_INSIGHTS,
      },
    ],
  })

  const handleSubmit = async (): Promise<void> => {
    const { data: deleteMarketData } = await deleteInsightMutation({
      variables: {
        id: marketId?.trim(),
      },
    }).catch((error) => {
      onError(error.message)
      return { data: null }
    })

    if (!deleteMarketData) {
      return
    }
    onSuccess()
    parentCallback()
  }

  return (
    <>
      <Title>{strings.DELETE_INSIGHT}</Title>
      <Paragraph style={{ marginTop: 0, marginBottom: 15 }}>
        {strings.DELETE_STATEMENT}
        <br />
      </Paragraph>
      <ButtonView>
        <Button
          type="button"
          text="Confirm"
          mainAction={false}
          loading={deletingInsight}
          onClick={handleSubmit}
        />
        <Button
          type="submit"
          text="Cancel"
          mainAction={false}
          loading={false}
          disabled={deletingInsight}
          onClick={onCancel}
        />
      </ButtonView>
    </>
  )
}

export default ConfirmDeleteInsight
